import { Component, ReactNode } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { AlertTriangle, RefreshCw, Home } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { LocalizedLink } from '@/components/LocalizedLink'

interface Props extends WithTranslation {
  children: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

class ErrorBoundaryClass extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    const { t } = this.props

    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="text-center max-w-md">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-6">
              <AlertTriangle className="h-8 w-8 text-red-600" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              {t('error.title')}
            </h1>
            <p className="text-gray-600 mb-8">
              {t('error.description')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={this.handleReload}>
                <RefreshCw className="mr-2 h-4 w-4" />
                {t('buttons.reloadPage')}
              </Button>
              <Button asChild variant="secondary">
                <LocalizedLink to="home">
                  <Home className="mr-2 h-4 w-4" />
                  {t('buttons.backToHome')}
                </LocalizedLink>
              </Button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export const ErrorBoundary = withTranslation('common')(ErrorBoundaryClass)
